import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Button, Paper, Stack, Typography } from '@mui/material';
import { consent, setConsent, setupAnalytics, pageView } from '@verfi/shared/dist/analytics/browser';
export default function Analytics() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(consent() === null);
  useEffect(() => {
    setupAnalytics({ token: process.env.REACT_APP_POSTHOG_KEY || '', environment: process.env.REACT_APP_VERFI_ENV || '', surface: 'proof', release: process.env.REACT_APP_RELEASE_SHA });
    pageView();
  }, [pathname]);
  return open ? <Paper component="section" aria-label="Analytics privacy choices" sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, p: 2, zIndex: 2147483647 }}>
    <Typography>Allow optional usage analytics to help improve Verfi? We do not record this page or collect proof contents. Declining does not affect access.</Typography>
    <Stack direction="row" spacing={2}><Button onClick={() => { setConsent('accepted'); setOpen(false); }}>Accept</Button><Button onClick={() => { setConsent('declined'); setOpen(false); }}>Decline</Button><Button href="https://verfi.io/privacy">Privacy policy</Button></Stack>
  </Paper> : <Button sx={{ position: 'fixed', bottom: 8, left: 8, zIndex: 1300, bgcolor: 'background.paper' }} onClick={() => setOpen(true)}>Privacy choices</Button>;
}
